import React from "react";
import SVG from "react-inlinesvg";
import {
  convertMinutesToHours,
  iconPath,
  dateGroupService,
} from "../../../../constants/constants";
import { PaginationBar } from "../../../../components/sharedComponents/PaginationBar";
import { useIntl } from "react-intl";
import { BsWallet, BsStopwatch, BsCalendar3 } from "react-icons/bs";

export const Group = ({
  mentorData,
  itemServices,
  handlePageChange,
  handleNavigation,
}) => {
  const path = iconPath();
  const { messages, locale } = useIntl();

  return (
    <div className="row">
      {itemServices?.data.map((service, index) => (
        <div className="col-lg-4 col-md-6" key={index}>
          <div className="book_ment_view">
            <h3 onClick={() => handleNavigation(service?.id)}>
              {service?.title}
            </h3>
            <p className="service-data--info">{service?.description}</p>
            <ul>
              <li>
                <SVG src={`${path}p1.svg`} />
                {service?.priceWTax} {messages["SAR"]}
                <span>
                  {mentorData?.vat_included
                    ? "(" + messages["vat_included"] + ")"
                    : ""}
                </span>
              </li>
              <li>
                <SVG src={`${path}p2.svg`} />{" "}
                {convertMinutesToHours(service?.period)}
                {messages["hour"]}
              </li>
              <li>
                <div className="service-data--wallet">
                  <BsCalendar3 />
                  <span>
                    {dateGroupService(service?.group_session_date, locale)}
                  </span>
                </div>
              </li>
            </ul>
            <button
              className="btn btn_booking w-100"
              onClick={() => handleNavigation(service?.id)}
            >
              {messages["book_session"]}
            </button>
          </div>
        </div>
      ))}

      <div className="col-12 d-flex justify-content-center mt-3">
        <PaginationBar
          totalPages={itemServices?.last_page}
          currentPage={itemServices?.current_page}
          handlePageChange={handlePageChange}
        />
      </div>
    </div>
  );
};
